/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SolidOps API
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod';

export const reactivateCustomerBodyExpectedCustomerVersionExclusiveMin = 0;
export const reactivateCustomerBodyExpectedCustomerVersionMax = 9007199254740991;

export const ReactivateCustomerBody = zod.object({
  expectedCustomerVersion: zod
    .int()
    .gt(reactivateCustomerBodyExpectedCustomerVersionExclusiveMin)
    .max(reactivateCustomerBodyExpectedCustomerVersionMax),
});

export type ReactivateCustomerBody = zod.input<typeof ReactivateCustomerBody>;
export type ReactivateCustomerBodyOutput = zod.output<typeof ReactivateCustomerBody>;
